// extracted by mini-css-extract-plugin
export default {"noOrderPlaceholder":"orders-tab_noOrderPlaceholder__Lzu6z"};